import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const fetchBase = process.env.REACT_APP_API_BASE_URL || "http://localhost:8082";

export default function EmployeeNotificationsPage() {
    const [notifications, setNotifications] = useState([]);
    const navigate = useNavigate();
    const token = localStorage.getItem("jwt_token");

    const fetchNotifications = async () => {
        try {
            const res = await fetch(`${fetchBase}/api/notifications`, {
                headers: { Authorization: "Bearer " + token }
            });
            const data = await res.json();
            if (Array.isArray(data)) setNotifications(data);
        } catch (err) {
            console.error("Failed to fetch notifications:", err);
        }
    };

    useEffect(() => {
        fetchNotifications();
    }, []);

    const markAsRead = async (id) => {
        await fetch(`${fetchBase}/api/notifications/${id}/read`, {
            method: "PATCH",
            headers: { Authorization: "Bearer " + token }
        });
        setNotifications(prev => prev.map(n => n.id === id ? { ...n, read: true } : n));
    };

    const markAllAsRead = async () => {
        await fetch(`${fetchBase}/api/notifications/read-all`, {
            method: "PATCH",
            headers: { Authorization: "Bearer " + token }
        });
        setNotifications(prev => prev.map(n => ({ ...n, read: true })));
    };

    return (
        <div style={{ minHeight: "100vh", background: "#f5f5f7" }}>
            <nav className="apple-global-nav">
                <div className="left-nav">
                    <img
                        src="/images/logoPlaceholder1.png"
                        alt="Logo"
                        className="apple-logo"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate("/employee/dashboard")}
                    />
                </div>
                <div className="center-nav">
                    <a href="/employee/dashboard">Dashboard</a>
                </div>
            </nav>
            <div style={{ maxWidth: "700px", margin: "60px auto", padding: "0 20px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
                    <h1 style={{ fontSize: "28px", fontWeight: "700", color: "#1d1d1f" }}>Notifications</h1>
                    <button
                        onClick={markAllAsRead}
                        style={{ fontSize: "13px", color: "#0071e3", background: "none", border: "none", cursor: "pointer" }}
                    >
                        Mark all as read
                    </button>
                </div>
                {notifications.length === 0 ? (
                    <p style={{ color: "#6e6e73", fontSize: "14px" }}>No notifications yet.</p>
                ) : (
                    notifications.map(n => (
                        <div
                            key={n.id}
                            onClick={() => !n.read && markAsRead(n.id)}
                            style={{
                                background: n.read ? "#fff" : "#f0f7ff",
                                border: "1px solid #e0e0e0",
                                borderRadius: "12px",
                                padding: "16px 20px",
                                marginBottom: "12px",
                                cursor: n.read ? "default" : "pointer",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "flex-start"
                            }}
                        >
                            <div>
                                <p style={{ fontWeight: "600", fontSize: "14px", margin: "0 0 4px", color: "#1d1d1f" }}>{n.title}</p>
                                <p style={{ fontSize: "13px", color: "#6e6e73", margin: 0 }}>{n.message}</p>
                                <p style={{ fontSize: "11px", color: "#aaa", margin: "6px 0 0" }}>
                                    {new Date(n.createdAt).toLocaleString()}
                                </p>
                            </div>
                            {!n.read && (
                                <span style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#0071e3", display: "inline-block", marginTop: "4px", flexShrink: 0 }} />
                            )}
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}